import 'whatwg-fetch';
import 'url-search-params-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { StepDocUploadComponent } from './components/stepComponent/StepDocUploadComponent';
import { StepPendingComponent } from './components/stepComponent/StepPendingComponent';
import { StepSSOComponent } from './components/stepComponent/StepSSOComponent';
import { StepSuccessComponent } from './components/stepComponent/StepSuccessComponent';
import { StepStudentPersonalInfoComponent } from './components/stepComponent/StepStudentPersonalInfoComponent';

// SheerID stuff
import { setOptions, overrideComponent } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';

// @ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
// @ts-ignore
overrideComponent('StepPendingComponent', StepPendingComponent);
overrideComponent('StepSSOComponent', StepSSOComponent);
// @ts-ignore
overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);

setOptions(defaultOptions);
googleTagManagerHook();

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
